import PropTypes from 'prop-types';
import React from 'react';
import styles from './StripComponent.less';

export default class extends React.Component {
    static displayName = 'StripComponent';

    static propTypes = {
        dir: PropTypes.string,
        settingsActions: PropTypes.object
    };

    static defaultProps = {
        dir: 'ltr'
    };

    render() {
        const { dir } = this.props;
        return (
            <div ref={el => this.container = el} className={`${styles.wrapper} ${styles[dir]}`}>
                <div className={styles.innerContainer}>{this.props.children}</div>
            </div>
        );
    }
}